<template>
  <div class="h-full">
    <div class="flex mb-20px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="请输入请输入关键字"
        v-model="jobSearchData.keywords"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择作业区域"
        v-model="jobSearchData.areaId"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <department-select
        ref="departmentSelect"
        class="mr-10px !w-50"
        v-model="jobSearchData.belongUnit"
      ></department-select>
      <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
      <el-button size="small" @click="resetText()">重置</el-button>
    </div>
    <el-table
      ref="table"
      :data="jobDataList"
      border
      class="w-full"
      :height="tableHeight"
      stripe
      v-loading="jobTableLoading"
      @selection-change="handleSelection"
      :row-key="getRowKeys"
      @cell-click="cellClick"
    >
      <el-table-column
        :reserve-selection="multiple"
        type="selection"
        width="50"
        v-if="multiple"
      ></el-table-column>
      <el-table-column label="序号" type="index" width="50"></el-table-column>
      <el-table-column
        label="风险点名称"
        prop="riskPointName"
        width="180"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="风险点编号"
        prop="riskPointNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="风险点类型"
        prop="riskPointType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="所属单位"
        width="120"
        prop="belongUnitName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="区域"
        width="120"
        prop="activityArea"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="jobTableSizeChange"
      @current-change="jobTableCurrentChange"
      :current-page.sync="jobPageConfig.SkipCount"
      :page-size.sync="jobPageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="jobTotalCount"
      class="float-right mt-10px mb-10px ml-10px"
    ></el-pagination>
  </div>
</template>

<script>
import { AreaApi } from '@wiz-api/area-management'
import { SourcesDangerRecognitionPlanTaskApi } from '@wiz-api/double-prevention-management'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'

const areaApi = new AreaApi()
const sourcesDangerRecognitionPlanTaskApi = new SourcesDangerRecognitionPlanTaskApi()

export default {
  name: 'job-point-table',
  components: {
    DepartmentSelect,
  },
  props: {
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      areaList: [],
      // 作业活动清单
      jobDataList: [],
      jobTableLoading: false,
      jobTotalCount: 0,
      jobSearchData: {},
      jobPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionData: [],
    }
  },
  watch: {
    selectionData(list) {
      this.$emit('sumCount', {
        key: 'jobCount',
        value: list.length,
      })
    },
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    selectIds() {
      return this.id ? this.id.split(',') : []
    },
    selectNames() {
      return this.name ? this.name.split(',') : []
    },
  },
  created() {
    this.getJobList()
    // 获取区域列表
    this.getAreaList()
  },
  mounted() {
    if (this.multiple) {
      this.setSelect()
    }
  },
  methods: {
    setSelect() {
      if (this.selectIds.length === this.selectNames.length) {
        this.selectIds.forEach((id, index) => {
          this.$refs.table.toggleRowSelection({ id, jobName: this.selectNames[index] })
        })
      }
    },
    getRowKeys(row) {
      return row.id
    },
    cellClick(row) {
      if (!this.multiple) {
        this.selectionData = [row]
        this.$emit('handleOk')
      }
    },
    // 选中结果事件
    handleSelection(values) {
      if (this.multiple) {
        this.selectionData = values
      }
    },
    // 重置
    resetText() {
      this.jobSearchData = this.$options.data().jobSearchData
      this.handleSearch()
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 搜索 equip 设备设施 job 作业活动
    handleSearch() {
      this.jobPageConfig.SkipCount = 1
      this.getJobList()
    },
    // 页码改变
    jobTableSizeChange(MaxResultCount) {
      this.jobPageConfig.MaxResultCount = MaxResultCount
      this.getJobList()
    },
    // 页数改变
    jobTableCurrentChange(SkipCount) {
      this.jobPageConfig.SkipCount = SkipCount
      this.getJobList()
    },
    // 作业活动列表
    async getJobList() {
      const data = {
        riskPointType: 0,
        maxResultCount: this.jobPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.jobPageConfig.SkipCount - 1) * this.jobPageConfig.MaxResultCount, // 跳过多少条
        ...this.jobSearchData,
      }
      this.jobTableLoading = true

      // const [err, res] = await jobActivityListApi.pagedListQuery(data)
      const [err, res] = await sourcesDangerRecognitionPlanTaskApi.riskPointPagedListQuery(data)
      if (!err) {
        this.jobDataList = res.items.map((item) => {
          item.id = item.riskPointId
          item.jobName = item.riskPointName
          return item
        })
        this.jobTotalCount = res.totalCount
      }
      this.jobTableLoading = false
    },
  },
}
</script>

<style></style>
